// src/components/NoData/NoData.jsx
import React from "react";
import Lottie from "lottie-react";
import noDataAnimation from "../../icons/non data found.json"; // مسیر فایل Lottie خودت

const NoData = ({ message = "هیچ داده‌ای یافت نشد", height = 200 }) => {
  return (
    <div className="no-data-container">
      <div className="no-data-content">
        <div className="lottie-wrapper">
          <Lottie animationData={noDataAnimation} loop={true} style={{ height: `${height}px` }} />
        </div>
        <p className="no-data-text">{message}</p>
      </div>

      <style>{`
        .no-data-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 50px 20px;
          background: #f9f9f9;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          transition: transform 0.3s ease, background 0.3s ease;
        }

        .no-data-container:hover {
          transform: translateY(-5px);
          background: #f0f0f0;
        }

        .no-data-content {
          text-align: center;
        }

        .lottie-wrapper {
          margin-bottom: 15px;
        }

        .no-data-text {
          font-size: 18px;
          color: #6b7280;
          font-weight: 500;
        }
      `}</style>
    </div>
  );
};

export default NoData;
